<template>
  <div class="Tabs">
    <div class="TabsList">
      <div class="table">
        <div class="TabsText" :class="[currentTable == 0? '    ':'']" @click="getWidth(0)"  :style="{ width: LayerTextWidth + 'px' }">
          <!--    :style="{ width: LayerTextWidth + 'px' }" -->
          SDGs与社会
        </div>
        <div class="TabsText" @click="getWidth(1)"  :style="{ width: LayerTextWidth + 'px' }">
          <!--     :style="{ width: LayerTextWidth + 'px' }" -->
         SDGs与科技
        </div>
        <div class="TabsText" @click="getWidth(2)"  :style="{ width: LayerTextWidth + 'px' }">
          <!--     :style="{ width: LayerTextWidth + 'px' }" -->
         实践案例
        </div>
     
        <div class="Tabs_active" :style="{ left: left + 'px' }">
          <div class="Tabs_active_bar"></div>
        </div>
      </div>
    </div>     
  </div>
</template>

<script>
export default {
  data() {
    return {
      LayerTextWidth: 200,
      left: 0,
      currentTable: 1,
    };
  },
  methods: {
    getWidth(val) {
      this.currentTable = val;
      
        this.left = val * this.LayerTextWidth;
    
      
      
    },
  },
};
</script>

<style lang="scss" scoped>
.Tabs {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #ccc;
  .TabsList {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    // background: #495057;
    .table {
      display: flex;
      flex-direction: row;
      position: relative;
      .TabsText {
        display: inline-block;
        cursor: pointer;
        color: #000;
        text-align: center;
        min-width: 0;
        font-size: 18px;
        font-weight: 600;
        min-height: 60px;
        // padding-left: 20px;
        // padding-right: 20px;
        line-height: 60px;
      }
    }
    .Tabs_active {
      width: 200px;
      padding: 0 20px;
      bottom: 0;
      height: 4px;
      position: absolute;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      .Tabs_active_bar {
        width: 120px;
        height: 4px;
        margin: auto;
        background: url("../../../assets/image/AppMarket/bar.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>